import React, { useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { getTranslate } from "react-localize-redux";
import ColumnToggleMenu from "./ColumnToggleMenu";
import moment from "moment";
import ReactTooltip from "react-tooltip";
import axios from "axios";
import {
  Modal,
  ModalBody,
  ModalFooter,
  ListGroup,
  ListGroupItem,
  ListGroupItemHeading,
  ListGroupItemText,
  Alert,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button,
  ModalHeader,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import {
  fileActions,
  msgActions,
  loaderMaskActions,
} from "../../../../redux/actions";
import { formatSizeUnits, getFilesParams } from "../../../../utils";
import MessageWithTruncating from "../../../../components/MessageWithTruncating";
import { FileTechnicalModal } from "./FileTechnicalModal";

function FilesGrid({
  translate,
  fileSearch,
  user,
  subUser,
  isSubUser,
  externalCustomerId,
  defaultSize,
  items,
  dispatch,
  history,
  hiddenColumns,
  selectedFlowIdsChannels,
  selectedFiles,
}) {
  const [fileBBReasons, setFileBBReasons] = useState(null);
  const [menuOpenIndex, setMenuOpenIndex] = useState(-1);
  const [confirmDeleteFileModal, setConfirmDeleteFileModal] = useState(false);
  const [fileToRemove, setFileToRemove] = useState(null);
  const [deleteFileReason, setDeleteFileReason] = useState("");

  const [technicalModal, setTechnicalModal] = useState(false);
  const [filesBucketData, setFilesBucketData] = useState(null);
  const [paramsForTechnicalData, setParamsForTechnicalData] = useState(null);
  const [filesBucketEventsData, setFilesBucketEventsData] = useState(null);
  const [filesBucketOrphansData, setFilesBucketOrphansData] = useState(null);
  const [activeTab, setActiveTab] = useState("1");
  const [isTechnicalOldFile, setIsTechnicalOldFile] = useState(false);

  const [modalDialog, setModalDialog] = useState(false);
  const [modalDialogHeader, setModalDialogHeader] = useState("");
  const [modalDialogBody, setModalDialogBody] = useState("");

  const toggleModalDialog = () => {
    setModalDialog(!modalDialog);
  };

  const showDialog = (dialogHeader, dialogBody) => {
    setModalDialog(true);
    setModalDialogHeader(dialogHeader);
    setModalDialogBody(dialogBody);
  };

  const handleShowTechnical = async (e, file) => {
    e.preventDefault();
    const params = {
      FidFs: file.fidfs,
    };
    try {
      dispatch(loaderMaskActions.show("Loading File Technicals..."));
      const response = await axios.get("Tracking/GetFilesBucket", {
        params,
      });
      const json = response.data;
      if (json.Errors && json.Errors.length > 0) {
        dispatch(msgActions.error("File Bucket", json.Errors[0]));
        return;
      }
      const filesBucketData = json.Data || {};
      setTechnicalModal(true);
      setParamsForTechnicalData(params);
      setFilesBucketData(filesBucketData);
      setActiveTab("1");
      setIsTechnicalOldFile(isOldFile(file));
    } catch (error) {
      dispatch(msgActions.error("Loading File Technicals", error.message));
    } finally {
      dispatch(loaderMaskActions.hide(""));
    }
  };

  const toggleTechnicalModal = () => {
    setTechnicalModal(false);
    setFilesBucketEventsData(null);
    setFilesBucketOrphansData(null);
  };

  if (items.length === 0) {
    return (
      <div className="empty-text">
        <p>{translate("No files match the specified filter")}</p>
      </div>
    );
  }

  const toggleConfirmDeleteFileModal = () => {
    setConfirmDeleteFileModal(!confirmDeleteFileModal);
  };

  const handleDeleteFileReasonChange = (e) => {
    setDeleteFileReason(e.target.value);
  };

  const handleYesConfirmDeleteDialog = () => {
    var currentUser = user;
    if (isSubUser) {
      currentUser = subUser;
    }
    const { userId } = currentUser || {};
    if (!deleteFileReason || deleteFileReason.length < 4) {
      dispatch(
        msgActions.error(
          "Remove Files",
          "Please enter the reason. It should be at least 4 chars long."
        )
      );
      return;
    }
    let params = {
      FlowIdFileStart: [fileToRemove && fileToRemove.fidfs],
      UserName: userId,
      TimeStamp: moment().toISOString(),
      Reason: deleteFileReason,
    };
    axios.post("Tracking/RemoveFlow", params).then((response) => {
      var json = response.data;
      if (json.Errors && json.Errors.length) {
        dispatch(msgActions.error("Remove Files", json.Errors[0]));
        return;
      }
      dispatch(
        msgActions.success("Remove Files", "File removed successfully.")
      );
      dispatch(
        fileActions.getAll(
          getFilesParams({ ...fileSearch }, isSubUser, externalCustomerId),
          `${translate("LoadingFiles")}...`
        )
      );
    });
  };

  const handleReactivateFile = (e, file) => {
    let params = {
      fidFs: [file && file.fidfs],
    };

    axios.put("Tracking/activateFilesBuckets", params).then((response) => {
      var json = response.data;
      if (json.Errors && json.Errors.length) {
        dispatch(msgActions.error("Reactivate File", json.Errors[0]));
        return;
      }
      dispatch(
        msgActions.success("Reactivate File", "File Reactivated successfully.")
      );
      dispatch(
        fileActions.getAll(
          getFilesParams({ ...fileSearch }, isSubUser, externalCustomerId),
          `${translate("LoadingFiles")}...`
        )
      );
    });
  };

  const closeFileBBReasonsModel = () => {
    setFileBBReasons(null);
  };

  const toggleRowMenu = (index) => {
    setMenuOpenIndex(menuOpenIndex !== index ? index : -1);
  };

  const handleOpenIncidentsMode = (e, file) => {
    e.preventDefault();
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();

    let dialogBody = (file.incidents || []).map((incident, i) => {
      return (
        <div
          key={i}
          className="list-group-item list-group-item-bordless"
          style={{ textAlign: "center" }}
        >
          <a href={incident.link} target="_blank" rel="noopener noreferrer">
            {incident.ticket}
          </a>
        </div>
      );
    });
    showDialog("Service Now Items", dialogBody);
  };

  const showActualChannelDialog = (channelName, actualChannels) => {
    let dialogBody = (
      <div className="row">
        <div className="col-12">
          <div className="list-group-item list-group-item-bordless">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div className="row" style={{ lineHeight: "1.5rem" }}>
                <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3 col-3">
                  <strong>Channel</strong>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3 col-3">
                  <strong>Delivered</strong>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3 col-3">
                  <strong>Rejected</strong>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3 col-3">
                  <strong>Breach Time</strong>
                </div>
              </div>
              {actualChannels &&
                actualChannels.map((item, index) => {
                  return (
                    <div
                      key={index}
                      className="row"
                      style={{ lineHeight: "1.5rem" }}
                    >
                      <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3 col-3">
                        {item.channelname}
                      </div>
                      <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3 col-3">
                        {item.delivered}
                      </div>
                      <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3 col-3">
                        {item.rejected}
                      </div>
                      <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3 col-3">
                        {item.slabreachtime
                          ? moment
                              .utc(item.slabreachtime, moment.ISO_8601)
                              .format("DD-MM-YYYY HH:mm:ss")
                          : "n/a"}
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
    );
    showDialog("Channel: " + channelName, dialogBody);
  };

  const openDocumentBucket = (file, channel, index) => {
    dispatch(fileActions.setActiveRow(index));
    let qData = {
      file_event_id: file.file.eventid,
      fidfs: file.fidfs,
      channel: channel.channelname,
    };
    if (isSubUser) {
      qData["CustomerId"] = externalCustomerId;
    }
    var qs = require("qs");
    history.push("/documents?" + qs.stringify(qData));
  };

  const showBBsReasons = async (e, file) => {
    e.preventDefault();
    try {
      const params = {
        FidFs: file.fidfs,
        customerid: file.customerid,
      };
      const response = await axios.get("Tracking/getfilesbucketbbs", {
        params,
      });
      const json = response.data;
      if (json.Errors && json.Errors.length > 0) {
        dispatch(msgActions.error("File Bucket", json.Errors[0]));
        return;
      }
      const { bbs } = json.Data || {};
      setFileBBReasons(
        <>
          <ListGroup>
            {(bbs || []).slice(0, 20).map((item, index) => (
              <ListGroupItem key={index}>
                <ListGroupItemHeading>{`${item.chfrom} ${
                  item.chfromoperator ? ` (${item.chfromoperator})` : ""
                } -> ${item.chto} ${
                  item.chtooperator ? ` (${item.chtooperator})` : ""
                }`}</ListGroupItemHeading>
                <ListGroupItemText>
                  <strong>{translate("Code")}: </strong>
                  {item.rcode}
                  <br />
                  <strong>{translate("Reason")}: </strong>
                  {item.rmsg && item.rmsg.length > 200 ? (
                    <MessageWithTruncating str={item.rmsg} maxLength={200} />
                  ) : (
                    item.rmsg
                  )}
                </ListGroupItemText>
              </ListGroupItem>
            ))}
          </ListGroup>
          {bbs && bbs.length > 20 && (
            <Alert color="light" style={{ paddingBottom: 0, marginBottom: 0 }}>
              {translate("tooManyBounceBacks")}
            </Alert>
          )}
        </>
      );
    } catch (error) {
      dispatch(msgActions.error("Loading File Technicals", error.message));
    }
  };

  const isFileChannelSelected = (fileId, channelName, channelOperator) => {
    var _flowIdChannel = selectedFlowIdsChannels.find(
      (o) => o.FlowIdFileStart === fileId
    );
    let _channel =
      _flowIdChannel &&
      (_flowIdChannel.ChannelsOperators || []).filter(
        (o) =>
          o.Channel === channelName &&
          ((!o.Operator && !channelOperator) || o.Operator === channelOperator)
      )[0];
    return !!_channel;
  };

  const isAllSelected = () => {
    const validItems = (items || []).filter((file) => !isOldFile(file));
    return (
      selectedFiles && validItems && selectedFiles.length === validItems.length
    );
  };
  const toggleMultiSelectAll = () => {
    dispatch(fileActions.toggleSelectAll(defaultSize || 20));
  };

  const isOldFile = (file) => {
    const arrivalTime = moment.utc(file.file.timestamp, moment.ISO_8601);
    let _activeFileLimitDate = moment.utc().toDate();
    _activeFileLimitDate.setDate(
      _activeFileLimitDate.getDate() - (window.ActiveFileMaxAgeDays || 2)
    );
    return arrivalTime.toDate().getTime() < _activeFileLimitDate.getTime();
  };

  const handleRowClick = (e, file, index) => {
    var sel = getSelection().toString();
    let _el = e.target;
    let _action = _el.getAttribute("data-action");
    if (!sel || _action === "open_incidents_mod") {
      if (_action !== "multi-select-action")
        dispatch(fileActions.setActiveRow(index));
      switch (_action) {
        case "open_flow":
          if (isOldFile(file)) {
            dispatch(
              msgActions.error(
                "File Details",
                "Operational data related to this item has expired"
              )
            );
          } else {
            history.push("/flows?id=" + file.file.eventid);
          }
          break;
        case "open_documentbucketall":
          let qData = {
            file_event_id: file.file.eventid,
            fidfs: file.fidfs,
          };
          if (fileSearch.CustomerId) {
            qData["CustomerId"] = fileSearch.CustomerId;
          } else if (isSubUser) {
            qData["CustomerId"] = externalCustomerId;
          }
          var qs = require("qs");
          history.push("/documents?" + qs.stringify(qData));
          break;
        case "open_incidents_mod":
        case "multi-select-action":
          break;
        default:
          dispatch(fileActions.expandRow(index));
          break;
      }
    }
  };

  const toggleRowMultiSelect = (e, file) => {
    if (!isOldFile(file)) {
      dispatch(fileActions.setFileSelection(file.fidfs));
    }
  };

  const toggleChannelRowMultiSelect = (
    e,
    file,
    channelName,
    channelOperator
  ) => {
    dispatch(
      fileActions.setChannelFileSelection(
        file.fidfs,
        channelName,
        channelOperator
      )
    );
  };

  const isFileSelected = (fileId) => {
    return selectedFiles.includes(fileId);
  };

  const handleRemoveFile = (e, file) => {
    e.stopPropagation();
    setConfirmDeleteFileModal(true);
    setFileToRemove(file);
  };

  return (
    <div className="col-12" style={{ padding: "0px" }}>
      <div className="row files-wrapper" style={{ margin: "0px" }}>
        <table
          className="table-bordered table-condensed cf table-hover table-sm panel-default col-12 col-lg-offset-0 card-list-table"
          cellSpacing="0"
          style={{ border: "0px", padding: "0px" }}
        >
          <thead
            style={{ background: "#3A4A57", color: "#fff" }}
            className="grids_header"
          >
            <tr style={{ fontSize: ".8rem" }}>
              {!isSubUser && (
                <th className="text-center">
                  <input
                    type="checkbox"
                    //data-action="multi-select-action"
                    name="check-all"
                    checked={isAllSelected()}
                    //onClick={e => e.stopPropagation()}
                    onChange={(e) => {
                      toggleMultiSelectAll(e);
                    }}
                  />
                </th>
              )}
              <th className="text-center">
                <div className="header-container" style={{ display: "block" }}>
                  <ColumnToggleMenu currentColumn="generic" />
                </div>
              </th>
              {!isSubUser && (
                <th className="text-center">
                  <span>SLA</span>
                </th>
              )}
              {!hiddenColumns.includes("customer") &&
                !isSubUser &&
                !fileSearch.CustomerId && (
                  <th>
                    <div className="header-container">
                      <div className="title">{translate("Customer")}</div>
                      <ColumnToggleMenu currentColumn="customer" />
                    </div>
                  </th>
                )}
              {!hiddenColumns.includes("platform") && !isSubUser && (
                <th>
                  <div className="header-container">
                    <div className="title">{translate("Platform")}</div>
                    <ColumnToggleMenu currentColumn="platform" />
                  </div>
                </th>
              )}
              {!hiddenColumns.includes("file") && (
                <th>
                  <div className="header-container">
                    <div className="title">{translate("File")}</div>
                    <ColumnToggleMenu currentColumn="file" />
                  </div>
                </th>
              )}
              {!hiddenColumns.includes("documents") && (
                <th>
                  <div className="header-container">
                    <div className="title">{translate("Documents")}</div>
                    <ColumnToggleMenu currentColumn="documents" />
                  </div>
                </th>
              )}
              {!hiddenColumns.includes("flow") && (
                <th className="text-center">
                  <div className="header-container">
                    <div className="title">{translate("Flow")}</div>
                    <ColumnToggleMenu currentColumn="flow" />
                  </div>
                </th>
              )}
              {!hiddenColumns.includes("flowName") && (
                <th>
                  <div className="header-container">
                    <div className="title">{translate("flowName")}</div>
                    <ColumnToggleMenu currentColumn="flowName" />
                  </div>
                </th>
              )}
              {!hiddenColumns.includes("channels") && (
                <th>
                  <div className="header-container">
                    <div className="title">{translate("Channels")}</div>
                    <ColumnToggleMenu currentColumn="channels" />
                  </div>
                </th>
              )}
              {!hiddenColumns.includes("errors") && !isSubUser && (
                <th>
                  <div className="header-container">
                    <div className="title">{translate("Errors/Incidents")}</div>
                    <ColumnToggleMenu currentColumn="errors" />
                  </div>
                </th>
              )}
              {!hiddenColumns.includes("arrivalTime") && (
                <th>
                  <div className="header-container">
                    <div className="title">{translate("ArrivalTime")}</div>
                    <ColumnToggleMenu currentColumn="arrivalTime" />
                  </div>
                </th>
              )}
              {!hiddenColumns.includes("completionTime") && (
                <th>
                  <div className="header-container">
                    <div className="title">{translate("CompletionTime")}</div>
                    <ColumnToggleMenu currentColumn="completionTime" />
                  </div>
                </th>
              )}
              {!hiddenColumns.includes("status") && (
                <th className="text-center">
                  <div className="header-container">
                    <div className="title">{translate("Status")}</div>
                    <ColumnToggleMenu currentColumn="status" />
                  </div>
                </th>
              )}
            </tr>
          </thead>
          <tbody style={{ backgroundColor: "#fff", fontSize: "12px" }}>
            {items &&
              items.map((file, index) => {
                var channels_count = (file.channels || []).length,
                  channelList = [],
                  atLeastOneChannelHasRejectCount = false,
                  atLeastOneChannelHasBouncebackCount = false,
                  atLeastOneChannelHasCancelledCount = false,
                  atLeastOneChannelHasDiffExpectedCount = false,
                  atLeastOneChannelWithBbExpected = false,
                  _channelText = "";

                if (channels_count > 0) {
                  if (channels_count > 1) {
                    _channelText = <u>{translate("Multiple")}</u>;
                  } else {
                    _channelText = file.channels[0].channelname;
                  }

                  file.channels.forEach((channel, indx) => {
                    let actualChannelsBtn = null;
                    if (
                      channel.actualchannels &&
                      channel.actualchannels.length > 0 &&
                      !isSubUser
                    ) {
                      actualChannelsBtn = (
                        <button
                          onClick={(e) =>
                            showActualChannelDialog(
                              channel.channelname,
                              channel.actualchannels
                            )
                          }
                          className="finger btn btn-secondary btn-sm w_p_action_tooltip w_p_action_sub"
                        >
                          {channel.actualchannels.length}
                        </button>
                      );
                    }
                    if (channel.rejected > 0) {
                      atLeastOneChannelHasRejectCount = true;
                    }
                    if (channel.bb > 0) {
                      atLeastOneChannelHasBouncebackCount = true;
                    }
                    if (channel.cancelled > 0) {
                      atLeastOneChannelHasCancelledCount = true;
                    }
                    if (channel.expected !== channel.delivered) {
                      atLeastOneChannelHasDiffExpectedCount = true;
                    }
                    if (channel.bbexpected > 0) {
                      atLeastOneChannelWithBbExpected = true;
                    }
                    channel.channel_slastatus_text = "";
                    channel.slastatus_cls = "";
                    if (!channel.slastatus) {
                      channel.slastatus_cls = "sla-status-help";
                      channel.channel_slastatus_text = "calcfailed";
                    } else {
                      if (channel.slastatus === "calcfailed") {
                        channel.slastatus_cls = "sla-status-help";
                        channel.channel_slastatus_text = "calcfailed";
                      } else if (channel.slastatus === "paused") {
                        channel.slastatus_cls = "sla-status-paused";
                        channel.channel_slastatus_text = "paused";
                      } else if (channel.slastatus === "breachwarning") {
                        channel.slastatus_cls = "sla-status-error";
                        channel.channel_slastatus_text = "breachwarning";
                      } else if (channel.slastatus === "breached") {
                        channel.slastatus_cls = "sla-status-exclamation";
                        channel.channel_slastatus_text = "breached";
                      } else if (channel.slastatus === "ok") {
                        channel.channel_slastatus_text = "ok";
                      } else {
                        channel.slastatus_cls = "sla-status-help";
                        channel.channel_slastatus_text = "calcfailed";
                      }
                    }
                    channelList.push(
                      <tr
                        key={indx}
                        className={"row_tr ch-status-" + channel.status}
                      >
                        <td data-title="Channel" className="channel-cell">
                          {!isSubUser && (
                            <div
                              style={{ float: "left" }}
                              className="hidden-sm-screen"
                            >
                              <button
                                type="button"
                                className="btn btn-default finger w_p_action w_p_action_tooltip"
                                onClick={(e) => {
                                  openDocumentBucket(file, channel, index);
                                }}
                                title={translate("Open Documents")}
                              >
                                <span
                                  className="fa fa-file-alt"
                                  style={{ fontSize: "1.2rem" }}
                                  aria-hidden="true"
                                />
                              </button>
                            </div>
                          )}
                          <div className="channel-name-data">
                            {!isSubUser && channel.slastatus !== "ok" && (
                              <div
                                style={{
                                  float: "left",
                                  width: "27px",
                                  margin: "8px 3px",
                                }}
                                className={`${channel.slastatus_cls} ch-slastatus-icon hidden-sm-screen`}
                              >
                                {channel.slastatus === "ok" ? "" : "SLA "}
                              </div>
                            )}
                            <div
                              style={{
                                float: "left",
                                margin: "10px 3px 0 0",
                              }}
                            >
                              {channel.channelname}{" "}
                              {channel.channeloperator &&
                                ` (${channel.channeloperator})`}
                            </div>
                            {channel.channelname &&
                              channel.channelname.toLowerCase() === "ipost" && (
                                <>
                                  <button
                                    className="tooltip-btn"
                                    data-tip
                                    data-place="bottom"
                                    data-type="info"
                                    data-effect="solid"
                                    data-for="activationTip-ipost"
                                  >
                                    <i
                                      className="fa fa-question-circle"
                                      style={{
                                        padding: "15px 7px 8px",
                                        fontSize: "0.8em",
                                      }}
                                    />
                                  </button>
                                  <ReactTooltip
                                    className="customeTheme"
                                    id="activationTip-ipost"
                                  >
                                    <div>
                                      <p>{translate("iPostServiceMessage")}</p>
                                    </div>
                                  </ReactTooltip>
                                </>
                              )}
                            {actualChannelsBtn}
                          </div>
                        </td>
                        <td
                          data-title="Expected"
                          className="text-center expected-data hidden-sm-screen"
                        >
                          {channel.expected > 0 ? channel.expected : ""}
                          {channel.bbexpected > 0
                            ? " (+" + channel.bbexpected + ")"
                            : ""}
                        </td>
                        <td data-title="Delivered" className="text-center">
                          <span className="hidden-sm-screen">
                            {channel.delivered}
                          </span>
                          <span className="ls-screen-hidden">
                            {channel.delivered} out of {channel.expected}
                          </span>
                        </td>
                        <td
                          data-title="Rejected"
                          className="text-center rejected-data hidden-sm-screen"
                        >
                          {channel.rejected}
                        </td>
                        <td
                          data-title="Bounceback"
                          className="text-center bounceback-data hidden-sm-screen"
                        >
                          {channel.bb}
                        </td>
                        <td
                          data-title="Cancelled"
                          className="text-center  cancelled-data hidden-sm-screen"
                        >
                          {channel.cancelled}
                        </td>
                        <td
                          data-title="Completion time"
                          className="text-center"
                        >
                          <span className="hidden-sm-screen">
                            {channel.completiontime
                              ? moment
                                  .utc(channel.completiontime, moment.ISO_8601)
                                  .format("DD-MM-YYYY HH:mm:ss")
                              : "n/a"}
                          </span>
                          <span className="ls-screen-hidden">
                            {channel.completiontime
                              ? moment
                                  .utc(channel.completiontime, moment.ISO_8601)
                                  .format("DD-MM-YYYY HH:mm")
                              : "-"}
                          </span>
                        </td>
                        {!isSubUser && (
                          <td
                            data-title="Breach time"
                            className="text-center hidden-sm-screen"
                          >
                            {channel.slabreachtime
                              ? moment
                                  .utc(channel.slabreachtime, moment.ISO_8601)
                                  .format("DD-MM-YYYY HH:mm:ss")
                              : "n/a"}
                          </td>
                        )}
                        <td
                          data-title="Status"
                          style={{ padding: "0 0.5rem" }}
                          className={
                            "hidden-sm-screen ch-status-" + channel.status
                          }
                        >
                          <div style={{ float: "left" }}>
                            {translate(channel.status)}
                          </div>
                          <div style={{ float: "right" }}>
                            {!isSubUser && channel.status === "InProgress" && (
                              <input
                                type="checkbox"
                                disabled={!!isOldFile(file)}
                                data-action="multi-select-action"
                                name="check"
                                checked={isFileChannelSelected(
                                  file.fidfs,
                                  channel.channelname,
                                  channel.channeloperator
                                )}
                                onClick={(e) => e.stopPropagation()}
                                onChange={(e) => {
                                  toggleChannelRowMultiSelect(
                                    e,
                                    file,
                                    channel.channelname,
                                    channel.channeloperator
                                  );
                                }}
                              />
                            )}
                          </div>
                          {channel.rd && (
                            <>
                              <button
                                className="tooltip-btn"
                                style={{
                                  marginTop: "-6px",
                                }}
                                data-tip
                                data-place="bottom"
                                data-type="info"
                                data-effect="solid"
                                data-for={`activationTip-rcr-${file.fidfs}-${channel.channelname}`}
                              >
                                <i
                                  className="fa fa-question-circle"
                                  style={{
                                    padding: "0 7px",
                                    fontSize: "0.8em",
                                  }}
                                />
                              </button>
                              <ReactTooltip
                                className="customeTheme"
                                id={`activationTip-rcr-${file.fidfs}-${channel.channelname}`}
                              >
                                <div>
                                  <strong>{translate("Removed by")}: </strong>
                                  {channel.rd.userName}
                                  <br />
                                  <strong>{translate("Date")}: </strong>
                                  {channel.rd.timeStamp
                                    ? moment
                                        .utc(
                                          channel.rd.timeStamp,
                                          moment.ISO_8601
                                        )
                                        .format("DD-MM-YYYY HH:mm:ss")
                                    : "n/a"}
                                  <br />
                                  <strong>{translate("Reason")}: </strong>
                                  {channel.rd.reason}
                                </div>
                              </ReactTooltip>
                            </>
                          )}
                        </td>
                      </tr>
                    );
                  });
                }
                var chanels_short_html = (
                  <div className="col-sm-12 col-xs-12 col-md-12 col-lg-12">
                    {_channelText}
                  </div>
                );
                var doc_html = "";
                if (file.docs !== "n/a" && file.docs > 0) {
                  if (!!file.pdc) {
                    doc_html = (
                      <td
                        className="w_p_action finger w_p_action_tooltip file-docs-column"
                        data-action="open_documentbucketall"
                        data-container="body"
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title={translate("Open Documents")}
                        style={{ textAlign: "right", padding: "0 1em" }}
                      >
                        <div
                          className="file-docs-inner tooltip-btn"
                          data-action="open_documentbucketall"
                          style={{ fontSize: "1em" }}
                        >
                          <span
                            data-action="open_documentbucketall"
                            className="fa fa-file ls-screen-hidden"
                          />
                          {file.docs}{" "}
                          <span
                            data-action="open_documentbucketall"
                            className="fa fa-file-alt hidden-sm-screen"
                            style={{ fontSize: "1.5em" }}
                          />
                        </div>
                      </td>
                    );
                  } else {
                    doc_html = (
                      <td
                        className="file-docs-column"
                        style={{ textAlign: "right", padding: "0 1em" }}
                      >
                        {file.docs}
                      </td>
                    );
                  }
                } else {
                  if (file.docs === 0) {
                    doc_html = (
                      <td className="text-center file-docs-column">
                        <span className="fa fa-file ls-screen-hidden" />
                        TBD
                      </td>
                    );
                  } else {
                    doc_html = (
                      <td className="text-center file-docs-column">
                        <span className="fa fa-file ls-screen-hidden" />
                        {file.docs}{" "}
                      </td>
                    );
                  }
                }

                file.slastatus_text = "";
                file.slastatus_cls = "";
                if (!file.slastatus) {
                  file.slastatus_cls = "sla-status-help";
                  file.slastatus_text = "calcfailed";
                } else {
                  if (file.slastatus === "calcfailed") {
                    file.slastatus_cls = "sla-status-help";
                    file.slastatus_text = "calcfailed";
                  } else if (file.slastatus === "paused") {
                    file.slastatus_cls = "sla-status-paused";
                    file.slastatus_text = "paused";
                  } else if (file.slastatus === "breachwarning") {
                    file.slastatus_cls = "sla-status-error";
                    file.slastatus_text = "breachwarning";
                  } else if (file.slastatus === "breached") {
                    file.slastatus_cls = "sla-status-exclamation";
                    file.slastatus_text = "breached";
                  } else if (file.slastatus === "ok") {
                    file.slastatus_text = "ok";
                  } else {
                    file.slastatus_cls = "sla-status-help";
                    file.slastatus_text = "calcfailed";
                  }
                }
                return [
                  <tr
                    key={file.id}
                    className={
                      "row_tr finger w_p_action row-status-" +
                      file.status.id +
                      (file.mode === "test" ? " mode_color" : "") +
                      (file.isActive ? " active-row" : "") +
                      (file.expanded ? " expanded" : "")
                    }
                    onClick={(e) => {
                      handleRowClick(e, file, index);
                    }}
                  >
                    {!isSubUser && (
                      <td
                        data-action="multi-select-action"
                        onClick={(e) => toggleRowMultiSelect(e, file)}
                        className="text-center hidden-sm-screen"
                      >
                        <input
                          type="checkbox"
                          disabled={!!isOldFile(file)}
                          data-action="multi-select-action"
                          name="check"
                          checked={isFileSelected(file.fidfs)}
                          onClick={(e) => e.stopPropagation()}
                          onChange={(e) => {
                            toggleRowMultiSelect(e, file);
                          }}
                        />
                      </td>
                    )}
                    <td className="text-center hidden-sm-screen">
                      <span
                        className="fa fa-angle-double-down"
                        style={{ fontSize: "1.3em" }}
                      />
                    </td>
                    {!isSubUser && (
                      <td className="text-center hidden-sm-screen">
                        <span
                          className={`${file.slastatus_cls} w_p_action_tooltip ch-slastatus-icon`}
                        >
                          {file.slastatus === "ok" ? "" : "SLA"}
                        </span>
                      </td>
                    )}
                    {!hiddenColumns.includes("customer") &&
                      !isSubUser &&
                      !fileSearch.CustomerId && (
                        <td className="hidden-sm-screen">{file.customer}</td>
                      )}
                    {!hiddenColumns.includes("platform") && !isSubUser && (
                      <td className="hidden-sm-screen">
                        {file.pl && file.pl[0]}
                      </td>
                    )}
                    {!hiddenColumns.includes("file") && (
                      <td className="file-flow-column">
                        <div
                          className={
                            !isSubUser
                              ? "w_p_action underline finger w_p_action_tooltip"
                              : "w_p_action external_hide_link"
                          }
                          data-action={!isSubUser ? "open_flow" : ""}
                          title={
                            !isSubUser
                              ? isOldFile(file)
                                ? translate("OldDocFilesTip")
                                : translate("Open Flow")
                              : ""
                          }
                        >
                          {file.mode === "test" ? (
                            <span data-action={!isSubUser ? "open_flow" : ""}>
                              <i data-action={!isSubUser ? "open_flow" : ""}>
                                [TEST]
                              </i>{" "}
                              <b data-action={!isSubUser ? "open_flow" : ""}>
                                {file.file.shortname}
                              </b>
                              {!isSubUser && (
                                <span
                                  data-action={!isSubUser ? "open_flow" : ""}
                                  style={{
                                    marginLeft: "5px",
                                    fontSize: "0.8em",
                                  }}
                                >
                                  {"(" + formatSizeUnits(file.file.size) + ")"}
                                </span>
                              )}
                            </span>
                          ) : (
                            <span data-action={!isSubUser ? "open_flow" : ""}>
                              <b data-action={!isSubUser ? "open_flow" : ""}>
                                {file.file.shortname}
                              </b>
                              {!isSubUser && (
                                <span
                                  data-action={!isSubUser ? "open_flow" : ""}
                                  style={{
                                    marginLeft: "5px",
                                    fontSize: "0.8em",
                                  }}
                                >
                                  {"(" + formatSizeUnits(file.file.size) + ")"}
                                </span>
                              )}
                            </span>
                          )}
                        </div>
                      </td>
                    )}
                    {!hiddenColumns.includes("documents") && doc_html}
                    {!hiddenColumns.includes("flow") && (
                      <td
                        data-title="Flow/Project"
                        className="file-proj-column text-center"
                      >
                        <span>{file.flow}</span>
                      </td>
                    )}
                    {!hiddenColumns.includes("flowName") && (
                      <td className="hidden-sm-screen">{file.flowName}</td>
                    )}
                    {!hiddenColumns.includes("channels") && (
                      <td className="hidden-sm-screen">{chanels_short_html}</td>
                    )}
                    {!hiddenColumns.includes("errors") && !isSubUser && (
                      <td className="hidden-sm-screen text-center">
                        {file.errors}
                        {file.incidents && file.incidents.length > 0 && (
                          <span>
                            {" "}
                            /{" "}
                            <button
                              type="button"
                              onClick={(e) => handleOpenIncidentsMode(e, file)}
                              className="finger btn btn-secondary btn-sm w_p_action_sub"
                              style={{
                                verticalAlign: "initial",
                                padding: "0rem 0.5rem",
                                lineHeight: "1.3",
                              }}
                              data-action="open_incidents_mod"
                              data-incidents={JSON.stringify(file.incidents)}
                            >
                              {file.incidents.length}
                            </button>
                          </span>
                        )}
                      </td>
                    )}
                    {!hiddenColumns.includes("arrivalTime") && (
                      <td
                        data-title="Arrived"
                        className="file-date-column text-center"
                      >
                        <span className="ls-screen-hidden">
                          {file.file.timestamp
                            ? moment
                                .utc(file.file.timestamp, moment.ISO_8601)
                                .format("DD.MM.YYYY")
                            : "n/a"}
                        </span>
                        <span className="hidden-sm-screen">
                          {file.file.timestamp
                            ? moment
                                .utc(file.file.timestamp, moment.ISO_8601)
                                .format("DD-MM-YYYY HH:mm:ss")
                            : "n/a"}
                        </span>
                      </td>
                    )}
                    {!hiddenColumns.includes("completionTime") && (
                      <td
                        data-title={translate(file.status.id)}
                        className={
                          "file-date-column text-center " + file.status.id
                        }
                      >
                        <span className="ls-screen-hidden">
                          {file.status.id !== "InProgress" &&
                            (file.completiontime
                              ? moment
                                  .utc(file.completiontime, moment.ISO_8601)
                                  .format("DD.MM.YYYY")
                              : "n/a")}
                        </span>
                        <span className="hidden-sm-screen">
                          {file.completiontime
                            ? moment
                                .utc(file.completiontime, moment.ISO_8601)
                                .format("DD-MM-YYYY HH:mm:ss")
                            : "n/a"}
                        </span>
                      </td>
                    )}
                    {!hiddenColumns.includes("status") && (
                      <td
                        className="hidden-sm-screen"
                        style={{
                          display: "flex",
                          padding: "0.6em 0.3em",
                          border: "none",
                          borderTop: "1px solid #dee2e6",
                        }}
                      >
                        <div
                          style={{
                            textTransform: "uppercase",
                            float: "left",
                            textAlign: "center",
                            marginLeft: "1.5em",
                          }}
                          data-tip
                          data-place="bottom"
                          data-type="info"
                          data-effect="solid"
                          data-action="multi-select-action"
                          data-for={`FileStatusTip-${file.id}`}
                          className={
                            "tag-status-label status-" + file.status.id
                          }
                        >
                          {translate(file.status.id)}
                        </div>
                        {!isSubUser &&
                          file.status.id === "Removed" &&
                          !!file.fileRemovingData && (
                            <ReactTooltip
                              className="customeTheme"
                              id={`FileStatusTip-${file.id}`}
                            >
                              <div>
                                <div>
                                  <strong>{translate("Removed by")}: </strong>
                                  {file.fileRemovingData["userName"]}
                                </div>
                                <div>
                                  <strong>{translate("Date")}: </strong>
                                  {file.fileRemovingData["timeStamp"]
                                    ? moment
                                        .utc(
                                          file.fileRemovingData["timeStamp"],
                                          moment.ISO_8601
                                        )
                                        .format("DD.MM.YYYY")
                                    : "n/a"}
                                </div>
                                <div>
                                  <strong>{translate("Reason")}: </strong>
                                  {file.fileRemovingData["reason"]}
                                </div>
                              </div>
                            </ReactTooltip>
                          )}
                        {!isSubUser && (
                          <Dropdown
                            style={{ float: "right", marginLeft: "0.5em" }}
                            isOpen={menuOpenIndex === index}
                            toggle={() => toggleRowMenu(index)}
                          >
                            <DropdownToggle
                              size="sm"
                              className="btn-default btn-circle"
                              onClick={(e) => {
                                e.stopPropagation();
                              }}
                            >
                              <span data-icon="menu" className="">
                                <svg
                                  id="Layer_1"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 24 24"
                                  width="24"
                                  height="24"
                                >
                                  <path
                                    fill="#263238"
                                    fillOpacity=".6"
                                    d="M12 7a2 2 0 1 0-.001-4.001A2 2 0 0 0 12 7zm0 2a2 2 0 1 0-.001 3.999A2 2 0 0 0 12 9zm0 6a2 2 0 1 0-.001 3.999A2 2 0 0 0 12 15z"
                                  />
                                </svg>
                              </span>
                            </DropdownToggle>
                            <DropdownMenu right>
                              {/* <ShowTechnicalButton
                                file={file}
                                isOldFile={isOldFile(file)}
                              /> */}
                              <DropdownItem
                                size="sm"
                                data-action="multi-select-action"
                                onClick={(e) =>
                                  handleShowTechnical(e, file, isOldFile(file))
                                }
                              >
                                {translate("Technical")}
                              </DropdownItem>
                              {/* <ShowTechnicalButton /> */}
                              {file.status.id === "InProgress" &&
                                !isOldFile(file) && (
                                  <DropdownItem
                                    size="sm"
                                    data-action="multi-select-action"
                                    onClick={(e) => handleRemoveFile(e, file)}
                                  >
                                    {translate("Remove file")}
                                  </DropdownItem>
                                )}
                              {file.st === "exp" && !isOldFile(file) && (
                                <DropdownItem
                                  size="sm"
                                  data-action="multi-select-action"
                                  onClick={(e) => handleReactivateFile(e, file)}
                                >
                                  {translate("Reactivate")}
                                </DropdownItem>
                              )}
                            </DropdownMenu>
                          </Dropdown>
                        )}
                        {!isSubUser && file.st === "exp" && (
                          <>
                            <button
                              type="button"
                              className="tooltip-btn"
                              style={{
                                verticalAlign: "middle",
                                margin: "0px 5px",
                              }}
                              data-tip
                              data-place="bottom"
                              data-type="info"
                              data-effect="solid"
                              data-for="expFileTip"
                            >
                              <i className="fa fa-clock" />
                            </button>
                            <ReactTooltip
                              className="customeTheme"
                              id="expFileTip"
                            >
                              {translate("File processing expired")}
                            </ReactTooltip>
                          </>
                        )}
                        {!isSubUser && !!isOldFile(file) && (
                          <>
                            <button
                              type="button"
                              className="tooltip-btn"
                              style={{
                                verticalAlign: "middle",
                                margin: "0px 5px",
                                fontSize: "16px",
                              }}
                              data-tip
                              data-place="bottom"
                              data-type="info"
                              data-effect="solid"
                              data-for="oldDocFilesTip"
                            >
                              <i className="fa fa-hourglass-end" />
                            </button>
                            <ReactTooltip
                              className="customeTheme"
                              id="oldDocFilesTip"
                            >
                              {translate("OldDocFilesTip")}
                            </ReactTooltip>
                          </>
                        )}
                        {file.hasbbs && (
                          <button
                            type="button"
                            className="tooltip-btn finger w_p_action w_p_action_tooltip"
                            style={{
                              verticalAlign: "middle",
                              margin: "0px 5px",
                            }}
                            title={translate("ShowBouncebackReasons")}
                            data-action="multi-select-action"
                            onClick={(e) => showBBsReasons(e, file)}
                          >
                            <i
                              data-action="multi-select-action"
                              className="fa fa-info-circle"
                            />
                          </button>
                        )}
                        { Object.keys(file?.fileRejectionData || {}).length > 0 && (
                            <>
                              <button
                                  type="button"
                                  className="tooltip-btn"
                                  style={{
                                    verticalAlign: "middle",
                                    margin: "0px 5px",
                                    fontSize: "16px",
                                  }}
                                  data-tip
                                  data-place="bottom"
                                  data-type="info"
                                  data-effect="solid"
                                  data-for={`fileRejectionData-${ file.id }`}
                              >
                                <i className="fa fa-info-circle" />
                              </button>
                              <ReactTooltip
                                  className="customeTheme"
                                  id={`fileRejectionData-${ file.id }`}
                              >
                                <div>
                                  <p>{ translate('Message') }: { file.fileRejectionData.message }</p>
                                  <p>{ translate('Code') }: { file.fileRejectionData.code }</p>
                                </div>
                              </ReactTooltip>
                            </>
                        ) }
                      </td>
                    )}
                    <td className="ls-screen-hidden sm-screen-expand-column">
                      <span className="fa fa-angle-double-down" />
                    </td>
                  </tr>,
                  file.expanded && (
                    <tr
                      key={"sub_" + file.id}
                      className={"w_subtable_id row-status-" + file.status.id}
                    >
                      <td
                        colSpan="100%"
                        style={{
                          backgroundColor: "#FAFAFA",
                          borderBottomLeftRadius: "10px",
                          borderBottomRightRadius: "10px",
                        }}
                      >
                        <table
                          className={
                            "col-sm-10 mx-auto table-bordered table-condensed table-hover table-sm panel-default " +
                            (atLeastOneChannelHasRejectCount
                              ? " "
                              : "no-reject-count ") +
                            (atLeastOneChannelHasBouncebackCount
                              ? " "
                              : "no-bounceback-count ") +
                            (atLeastOneChannelHasCancelledCount
                              ? " "
                              : "no-cancelled-count ") +
                            (atLeastOneChannelHasDiffExpectedCount
                              ? " "
                              : "no-diff-expected-count ")
                          }
                          style={{ marginBottom: "5px" }}
                        >
                          <thead>
                            <tr>
                              <th>{translate("Channel")}</th>
                              <th className="text-center expected-data hidden-sm-screen">
                                {atLeastOneChannelWithBbExpected ? (
                                  <>
                                    <button
                                      type="button"
                                      className="add-issue-btn"
                                      style={{
                                        fontWeight: 700,
                                        fontSize: "12px",
                                      }}
                                      data-tip
                                      data-place="bottom"
                                      data-type="info"
                                      data-effect="solid"
                                      data-for={`ChannelWithBbExpectedTip_${file.id}`}
                                    >
                                      {`${translate("Expected")} (?)`}
                                    </button>
                                    <ReactTooltip
                                      className="customeTheme"
                                      id={`ChannelWithBbExpectedTip_${file.id}`}
                                    >
                                      <div
                                        style={{
                                          width: "500px",
                                          textAlign: "justify",
                                        }}
                                      >
                                        {translate("ChannelWithBBExpectedMsg")}
                                      </div>
                                    </ReactTooltip>
                                  </>
                                ) : (
                                  translate("Expected")
                                )}
                              </th>
                              <th className="text-center">
                                {translate("Delivered")}
                              </th>
                              <th className="text-center rejected-data hidden-sm-screen">
                                {translate("Rejected")}
                              </th>
                              <th className="text-center bounceback-data hidden-sm-screen">
                                {translate("BounceBack")}
                              </th>
                              <th className="text-center cancelled-data hidden-sm-screen">
                                {translate("Cancelled")}
                              </th>
                              <th className="text-center">
                                <span className="hidden-sm-screen">
                                  {translate("CompletionTime")}
                                </span>
                                <span className="ls-screen-hidden">
                                  {translate("TimeStamp")}
                                </span>
                              </th>
                              {!isSubUser && (
                                <th className="text-center hidden-sm-screen">
                                  {translate("BreachTime")}
                                </th>
                              )}
                              <th className="text-center hidden-sm-screen">
                                {translate("Status")}
                              </th>
                            </tr>
                          </thead>
                          <tbody>{channelList}</tbody>
                        </table>
                      </td>
                    </tr>
                  ),
                ];
              })}
          </tbody>
        </table>
      </div>
      <Modal
        isOpen={confirmDeleteFileModal}
        toggle={toggleConfirmDeleteFileModal}
      >
        <ModalHeader toggle={toggleConfirmDeleteFileModal}>
          {translate("Remove file")}
        </ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label htmlFor="messageText">
              {translate("EnterReasonRemoveFile")}
            </Label>
            <Input
              type="textarea"
              name="message"
              id="messageText"
              valid={!!deleteFileReason && deleteFileReason.length > 3}
              invalid={!!deleteFileReason && deleteFileReason.length < 4}
              placeholder={translate("Tell us more..")}
              value={deleteFileReason}
              onChange={handleDeleteFileReasonChange}
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter className="text-center">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={toggleConfirmDeleteFileModal}
          >
            {translate("Cancel")}
          </button>
          <Button
            color="primary"
            disabled={!deleteFileReason || deleteFileReason.length < 4}
            className="EventSearchSubmit"
            style={{ marginLeft: "20px" }}
            onClick={handleYesConfirmDeleteDialog}
          >
            {translate("Remove")}
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={modalDialog} toggle={toggleModalDialog}>
        <ModalHeader toggle={toggleModalDialog}>
          {modalDialogHeader}
        </ModalHeader>
        <ModalBody>{modalDialogBody}</ModalBody>
      </Modal>
      <Modal
        isOpen={!!fileBBReasons}
        toggle={closeFileBBReasonsModel}
        zIndex={"99999999999"}
        style={{ maxHeight: "calc(100vh - 60px)" }}
        contentClassName="fileBB-modal-content"
      >
        <ModalBody style={{ overflow: "auto" }}>{fileBBReasons}</ModalBody>
        <ModalFooter className="text-center">
          <button
            type="button"
            className="switchBtn"
            style={{ width: "100px" }}
            onClick={closeFileBBReasonsModel}
          >
            {translate("Close")}
          </button>
        </ModalFooter>
      </Modal>
      <FileTechnicalModal
        technicalModal={technicalModal}
        toggleTechnicalModal={toggleTechnicalModal}
        filesBucketData={filesBucketData}
        paramsForTechnicalData={paramsForTechnicalData}
        filesBucketEventsData={filesBucketEventsData}
        filesBucketOrphansData={filesBucketOrphansData}
        activeTab={activeTab}
        setFilesBucketEventsData={setFilesBucketEventsData}
        setFilesBucketOrphansData={setFilesBucketOrphansData}
        setActiveTab={setActiveTab}
        isTechnicalOldFile={isTechnicalOldFile}
      />
    </div>
  );
}

function mapStateToProps(state) {
  const { files, fileSearch, locale, authentication } = state;
  const { user, subUser, isSubUser } = authentication;
  return {
    user,
    subUser,
    isSubUser,
    files,
    fileSearch,
    hiddenColumns: files.hiddenColumns,
    selectedFlowIdsChannels: files.selectedFlowIdsChannels,
    selectedFiles: files.selectedFiles,
    translate: getTranslate(locale),
  };
}

const connectedFilesGrid = connect(mapStateToProps)(withRouter(FilesGrid));
export { connectedFilesGrid as FilesGrid };
